export default "__VITE_ASSET__a1yOXDsn__"